var $ = jQuery;
/* eslint-disable */
import featherlight from '../libs/featherlight.js';
/* eslint-enable */

const $results =  $('.results-wrapper');
const $button = $('.button-rsvp-modal');

function init() {
  if($('#rsvp-form').length > 0) {
    $button.featherlight('#rsvp-form', {
      otherClose: '.event__close-modal',
      root: '.page-node-type-event',
      variant: 'event__rsvp-modal',
      afterOpen: function(event) {
        $('.event__close-modal').focus();
      },
      beforeOpen: function() {
        window.getFormEvent();
      },
      afterClose: function() {
        window.removeFormEvent();
      }
    });
  }

  $(document).on('change', '.filter-wrapper__filter', function() {
    $results.find('.js-form-submit').trigger('click');
  });

  $('#rsvp-form').on('click', '#tHFSubscriber', function() {
    var checkedIt = $(this).prop('checked');
    var newVal = $(this).prop('checked') ===  true ? 'yes' : 'no';

    $('[name="tHFThisWeekatHeritageSubscriber"]').prop('checked', checkedIt);
    $('[name="tHFThisWeekatHeritageSubscriber"]').val(newVal);
    $('[name="tHFLecturesandSeminarsSubscriber"]').prop('checked', checkedIt);
    $('[name="tHFLecturesandSeminarsSubscriber"]').val(newVal);
  });

}

export { init as init };
